import { akeronService } from "./akeronService";

const section = "Line";

function filter(name = " ", from = "0", limit = "10", active = "1") {
    console.log("Filtering with:", name, from, limit, active);
  return akeronService.make_get_request(`${section}/ListProductLine/${name}/${from}/${limit}/${active}`, {}).then((response) => {
    let result = {
      quantity: response.quantity,
      list: response.lines,
    };
    console.log("Filter result:", result);
    return result;
  });
}

function getAll() {
  return akeronService.make_get_request(`${section}/ListAll`, {}).then((response) => {
    return response.lines;
  });
}

function remove(id) {
  console.log("Removing line product with id:", id);
  return akeronService.make_delete_request(`${section}/DeleteProductLine/${id}`, {})
    .then((response) => {
      console.log("Delete response:", response);
      return response;
    })
    .catch((error) => {
      console.error("Delete error:", error);
      throw error;
    });
}

function create(item) {
  const param = {
    Name: item.name,
  };
  return akeronService.make_post_request(`${section}/CreateProductLine`, param);
}

function update(item) {
  const param = {
    Id: item.id,
    Name: item.name,
    isActive: item.isActive !== undefined ? item.isActive : true,
  };
  return akeronService.make_put_request(`${section}/UpdateProductLine`, param);
}

export const lineaProductoService = {
  getAll,
  filter,
  remove,
  create,
  update,
};
